module.exports = __webpack_public_path__ + "static/img/112_TO8_1816_og.8642b30.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/112_TO8_1816_og.jpg
// module id = DpIC
// module chunks = 0